var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EndpageTemplate',{attrs:{"model":_vm.model,"recommended-events":_vm.recommendedEvents}})
}
var staticRenderFns = []

export { render, staticRenderFns }